import type { AccessProfileModalFormProps } from './types'

export const initialFormValues: AccessProfileModalFormProps = {
  profileDescription: '',
  profileType: '',
  status: '',
  observations: '',
  fullAccess: false
}
